import { createBrowserRouter } from "react-router-dom";
import Layouts from "../pages/Layouts";
import { lazy, Suspense } from "react";
import PermissionGuard, { DefaultRedirect } from "../component/PermissionGuard";
import Loading from "../component/Loading";
import NoPermission from "../pages/NoPermission";

const EventLibrary = lazy(() => import("../pages/EventManager"));
const AddEventLibrary = lazy(() => import("../pages/EventManager/AddEvent"));
const TimelineLibrary = lazy(() => import("../pages/TimelineTemplate"));
const AddTimelineTemplate = lazy(
  () => import("../pages/TimelineTemplate/AddTemplate")
);
const ViewTimelineTemplate = lazy(
  () => import("../pages/TimelineTemplate/ViewTemplate")
);
const AddTimelineInstance = lazy(
  () => import("../pages/TimelineInstance/AddTimelineInstance")
);
const ViewTimelineInstance = lazy(
  () => import("../pages/TimelineInstance/ViewTimelineInstance")
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layouts />,
    children: [
      {
        index: true,
        element: <DefaultRedirect />,
      },
      {
        path: "event-library",
        element: (
          <PermissionGuard permission="operate_event_library">
            <Suspense fallback={<Loading open />}>
              <EventLibrary />
            </Suspense>
          </PermissionGuard>
        ),
      },
      {
        path: "event-library/add",
        element: (
          <PermissionGuard permission="operate_event_library">
            <Suspense fallback={<Loading open />}>
              <AddEventLibrary />
            </Suspense>
          </PermissionGuard>
        ),
      },
      {
        path: "event-library/edit/:eventId",
        element: (
          <PermissionGuard permission="operate_event_library">
            <Suspense fallback={<Loading open />}>
              <AddEventLibrary />
            </Suspense>
          </PermissionGuard>
        ),
      },
      {
        path: "timeline-library",
        element: (
          <PermissionGuard permission="operate_timeline_library">
            <Suspense fallback={<Loading open />}>
              <TimelineLibrary />
            </Suspense>
          </PermissionGuard>
        ),
      },
      {
        path: "timeline-library/add",
        element: (
          <PermissionGuard permission="operate_timeline_library">
            <Suspense fallback={<Loading open />}>
              <AddTimelineTemplate />
            </Suspense>
          </PermissionGuard>
        ),
      },
      {
        path: "timeline-library/edit/:templateId",
        element: (
          <PermissionGuard permission="operate_timeline_library">
            <Suspense fallback={<Loading open />}>
              <AddTimelineTemplate />
            </Suspense>
          </PermissionGuard>
        ),
      },
      {
        path: "timeline-library/view/:templateId",
        element: (
          <PermissionGuard permission="operate_timeline_library">
            <Suspense fallback={<Loading open />}>
              <ViewTimelineTemplate />
            </Suspense>
          </PermissionGuard>
        ),
      },
      {
        // Hosting business module controls entry; Event route uses authenticated session only.
        path: "timeline-instance/add",
        element: (
          <Suspense fallback={<Loading open />}>
            <AddTimelineInstance />
          </Suspense>
        ),
      },
      {
        path: "timeline-instance/view",
        element: (
          <Suspense fallback={<Loading open />}>
            <ViewTimelineInstance />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "no-permission",
    element: <NoPermission />,
  },
  {
    path: "*",
    element: <NoPermission />,
  },
]);

export { router };

